var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-wrapper base-button"},[_c('a',{class:[_vm.size, _vm.theme],attrs:{"href":_vm.link}},[_vm._t("default"),_c('div',{staticClass:"icon"},[_c('b-icon',{attrs:{"icon":_vm.icon}})],1)],2)])}
var staticRenderFns = []

export { render, staticRenderFns }